import React from "react"
import {MainCP} from "../../Components/imagen-paises/MainCP"

const ViewImagenPaises: React.FC = () => <MainCP/>

export default ViewImagenPaises;